import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "footer-wrapper" }
const _hoisted_2 = { id: "footer-section" }
const _hoisted_3 = { class: "footer-info" }
const _hoisted_4 = { class: "material-icons info-icon" }
const _hoisted_5 = { class: "info-text" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "footer-info" }
const _hoisted_8 = { class: "material-icons info-icon" }
const _hoisted_9 = { class: "info-text" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "footer-info" }
const _hoisted_12 = { class: "material-icons info-icon location-icon" }
const _hoisted_13 = { class: "footer-info" }
const _hoisted_14 = { class: "material-icons info-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.DepartmentName), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("span", _hoisted_4, "phone_enabled", 512 /* NEED_PATCH */), [
            [_vShow, !!_ctx.Phone]
          ]),
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("a", {
              href: `tel:${_ctx.Phone}`
            }, _toDisplayString(_ctx.Phone), 9 /* TEXT, PROPS */, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("span", _hoisted_8, "mail", 512 /* NEED_PATCH */), [
            [_vShow, !!_ctx.Email]
          ]),
          _createElementVNode("span", _hoisted_9, [
            _createElementVNode("a", {
              href: `mailto:${_ctx.Email}`
            }, _toDisplayString(_ctx.Email), 9 /* TEXT, PROPS */, _hoisted_10)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("span", _hoisted_12, "place", 512 /* NEED_PATCH */), [
            [_vShow, !!_ctx.Address || !!_ctx.Zip || !!_ctx.City]
          ]),
          _withDirectives(_createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openGoogleMap && _ctx.openGoogleMap(...args))),
            class: "info-text location-address"
          }, [
            _createTextVNode(_toDisplayString(_ctx.Address) + ",", 1 /* TEXT */),
            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createTextVNode(" " + _toDisplayString(_ctx.Zip) + " " + _toDisplayString(_ctx.City), 1 /* TEXT */)
          ], 512 /* NEED_PATCH */), [
            [_vShow, !!_ctx.Address || !!_ctx.Zip || !!_ctx.City]
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("span", _hoisted_14, "location_city", 512 /* NEED_PATCH */), [
            [_vShow, !!_ctx.CVRNumber]
          ]),
          _withDirectives(_createElementVNode("div", { class: "info-text" }, "CVR: " + _toDisplayString(_ctx.CVRNumber), 513 /* TEXT, NEED_PATCH */), [
            [_vShow, !!_ctx.CVRNumber]
          ])
        ], 512 /* NEED_PATCH */), [
          [_vShow, _ctx.Config.showCVR]
        ])
      ])
    ])
  ]))
}